var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"calendar",attrs:{"target":"_blank","href":(_vm.base_url + "/videos/ics/" + (_vm.video.slug))}},[_c('BaseIcon',{attrs:{"name":['far', 'calendar-plus']}}),_vm._v(" Outlook ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }